"use strict";

require("./index");

require("./core");

require("./es2015");

require("./flow");

require("./jsx");

require("./misc");

require("./experimental");


//////////////////
// WEBPACK FOOTER
// ./~/babel-types/lib/definitions/init.js
// module id = 995
// module chunks = 168707334958949